import { MOD_ADMIN_SETTINGS_ROUTE, MOD_VIEW_ROUTE } from '@config/routeNames.js'
import { MEMBER_LEVEL_MANAGER } from '@config/options.js'
import i18n from '@plugins/localisation.js'

export const schema = {
  config: [
    {
      label: 'name',
      key: 'name',
      cellClass: 'tw-text-left',
      type: 'content',
      to: (item) => ({
        name: MOD_VIEW_ROUTE,
        params: {
          mod: item.name_id,
        },
      }),
    },
    {
      label: 'added',
      key: 'date_added',
      type: 'string',
      format: 'date',
      lowOpacity: true,
      cellClass: 'tw-hidden lg:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'downloads',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.downloads_total',
      cellClass: 'tw-hidden lg:tw-table-cell tw-text-left',
      sort: {
        key: 'downloads_total',
        direction: 'desc',
      },
    },
    {
      label: 'subscribers',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.subscribers_total',
      cellClass: 'tw-hidden xl:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'status',
      format: 'status',
      type: 'string',
      key: 'status',
      preStyleText: true,
      cellClass: 'tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'visibility',
      type: 'group',
      key: 'visible',
      cellClass: 'tw-text-center',
      sort: {
        direction: 'desc',
      },
      group: [
        (item) => ({
          type: 'icon',
          icon: item.visible ? 'eye' : 'eye-slash',
          tooltip: item.visible ? 'Visible' : 'Hidden',
          tooltipPos: 'top',
        }),
      ],
    },
    {
      label: 'role',
      key: 'access.level',
      type: 'string',
      preStyleText: true,
      cellClass: 'tw-text-left',
      format: 'role',
      sort: {
        direction: 'desc',
      },
    },
    {
      type: 'group',
      cellClass: 'tw-text-right',
      actionCell: true,
      sortable: false,
      group: [
        (item) => ({
          type: 'action',
          attrs: {
            autoWidth: true,
            secondary: true,
            disabled: item.access.level < MEMBER_LEVEL_MANAGER,
          },
          text: i18n.global.t('manage'),
          mobileIcon: 'pencil-alt',
          to: (item) => ({
            name: MOD_ADMIN_SETTINGS_ROUTE,
            params: {
              mod: item.name_id,
            },
          }),
        }),
      ],
    },
  ],
  defaultSort: 'date_added',
}
